<template>
	<div class="margin-left">
		<div class="blocka">
			<p class="text-666  text-left" v-if="status == 0">请上传您录制好的个人面试视频，上传视频审核通过后，会显示到找活名片内，且<span class="text-theme">送5积分</span></p>
			<p class="text-666  text-left" v-if="status == 1">面试视频已上传完毕，<span class="text-theme">平台正在审核中...</span></p>
			<p class="text-666  text-left" v-if="status == 2">您的面试视频审核不通过，<span class="text-theme">平台驳回了您的视频...</span></p>
			<p class="text-666  text-left" v-if="status == 3">视频已审核通过，<span class="text-theme">您的视频已显示在您找活名片中</span></p>
			<!-- <div class="blockup flex flex-direction justify-center align-center margin-top">
				<img src="../../assets/img/upvideo.png" >
				<p>上传视频</p>
			</div> -->

			<el-upload class="avatar-uploader margin-top" action="https://manage.ciiply.com/api/pc/user/upFile"
				v-bind:on-progress="uploadVideoProcess" v-bind:on-success="handleVideoSuccess"
				v-bind:before-upload="beforeUploadVideo" v-bind:show-file-list="false">
				<video v-if="videoForm.showVideoPath != '' && !videoFlag" v-bind:src="videoForm.showVideoPath"
					class="avatar video-avatar" controls="controls">
					您的浏览器不支持视频播放
				</video>
				<!-- <i v-else-if="videoForm.showVideoPath == '' && !videoFlag"
			     class="el-icon-plus avatar-uploader-icon"
			     ></i> -->
				<div v-else-if="videoForm.showVideoPath == '' && !videoFlag"
					class="blockup flex flex-direction justify-center align-center margin-top">
					<img src="../../assets/img/upvideo.png">
					<p>上传视频</p>
				</div>
				<el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent"
					style="margin-top: 7px"></el-progress>
			</el-upload>

			<!-- <div class="text-left margin-top">
				<span class="text-theme">温馨提示</span>：可按以下话术拍摄，老板您好我今年多少岁、从事哪个行业工龄多少年...
				1. 介绍您的工作经历？ 例如我是做什么行业岗位的工人，之前做过那些项目，在哪里... 2. 具备哪些资历证书? 我有哪个行业
			</div> -->
			<div class="text-sm text-left margin-top"><span class="text-theme">温馨提示：</span>您的视频已经上传完毕，若您感觉效果不满可以再次重新上传视频
			</div>
			<!-- <div class="sub-btn text-white">撤回，重新上传</div>
			<div class="sub-btn text-white">查看我的找活名片</div> -->
			<div class="sub-btn text-white" v-if="status < 3" @click="sub">{{status == 0?'确认提交':'重新上传'}}</div>
			<p>如有疑问请联系平台客服：<span class="text-theme">400-212-22</span></p>


		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				videoFlag: false,
				//是否显示进度条
				videoUploadPercent: "",
				//进度条的进度，
				isShowUploadVideo: false,
				//显示上传按钮
				videoForm: {
					showVideoPath: "", //回显的变量
				},
				status:'',//状态
			}
		},
		created() {
			this.getinfo()
		},
		methods: {
			/**
			 * 获取已填写的基本信息
			 * */
			getinfo(){
				this.ajax('get', '/api/userInfo/myUserInfo', { }, res => {
					console.log(res);
					if (res.status == 200) {
						let userInfo = null
						userInfo = res.data.userInfo&&res.data.userInfo.length == 0 ? null : res.data.userInfo
						if (userInfo) {
							this.videoForm.showVideoPath = userInfo.video?userInfo.video:'';
							if(this.videoForm.showVideoPath){
								this.isUpl = true
							}else{
								this.isUpl = false
							}
						}else{
							this.isUpl = false
						}
					} else {
						
					}
				})
			},
			//上传前回调
			beforeUploadVideo(file) {
				var fileSize = file.size / 1024 / 1024 < 50; //控制大小  修改50的值即可
				if (
					[
						"video/mp4",
						"video/ogg",
						"video/flv",
						"video/avi",
						"video/wmv",
						"video/rmvb",
						"video/mov",
					].indexOf(file.type) == -1 //控制格式
				) {
					layer.msg("请上传正确的视频格式");
					return false;
				}
				if (!fileSize) {
					layer.msg("视频大小不能超过50MB");
					return false;
				}
				this.isShowUploadVideo = false;
			},
			//进度条
			uploadVideoProcess(event, file, fileList) { //注意在data中添加对应的变量名
				this.videoFlag = true;
				this.videoUploadPercent = file.percentage.toFixed(0) * 1;
			},
			//上传成功回调
			handleVideoSuccess(res, file) {
				this.isShowUploadVideo = true;
				this.videoFlag = false;
				this.videoUploadPercent = 0;

				console.log(res);
				//后台上传数据
				if (res.status == 200) {
					this.videoForm.showVideoPath = res.data.url; //上传成功后端返回视频地址 回显
				} else {
					this.$message.error("上传失败！");
				}
			},
			sub(){
				this.ajax('post', '/api/userVideo/upVideo', {
					video: this.videoForm.showVideoPath
				}, res => {
					console.log(res);
					if (res.status == 200) {
						this.$message('上传成功');
						this.getinfo()
					} else {
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.blocka {
		width: 921px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		padding: 40px;
	}

	.blockup {
		width: 345px;
		height: 194px;
		background: #F7F7F7;
		border: 1px solid rgba(220, 217, 217, 0.6500);
		border-radius: 10px;
	}

	.sub-btn {
		width: 383px;
		height: 60px;
		line-height: 60px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2000);
		border-radius: 30px;
		margin: 100px auto 40px;
		font-size: 22px;
	}

	//视频
	// .avatar-uploader-icon {
	//   border: 1px dashed #d9d9d9 !important;
	// }
	/deep/ .el-upload {
		display: block;
	}

	.avatar-uploader .el-upload {
		display: block;
		border: 1px dashed #d9d9d9 !important;
		border-radius: 6px !important;
		position: relative !important;
		overflow: hidden !important;
	}

	.avatar-uploader .el-upload:hover {
		border: 1px dashed #d9d9d9 !important;
		border-color: #409eff;
	}

	// .avatar-uploader-icon {
	//   font-size: 28px;
	//   color: #8c939d;
	//   width: 300px;
	//   height: 178px;
	//   line-height: 178px;
	//   text-align: center;
	// }
	.avatar {
		width: 300px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/view/my/frequency.vue